
import OPicture from "@/components/base/image/OPicture"
import ResponsiveVimeo from "@/components/base/video/ResponsiveVimeo"
import CheckboxField from "@/components/search/v2/header/filters/CheckboxField"
import media from "@/mixins/media"
import { mdiVideo } from "@mdi/js"

export default {
    name: "MediaGallery",
    components: { OPicture, ResponsiveVimeo, CheckboxField },
    mixins: [media],
    model: {
        event: "select",
        prop: "selected",
    },
    props: {
        numCols: {
            type: Number,
            default: 3,
            validator: (value) => [1, 2, 3, 4, 6, 12].includes(value),
        },
        selected: {
            type: Array,
            default: () => [],
        },
        gallery: {
            type: Object,
            required: true,
        },
        mediaType: {
            type: String,
            default: "all",
            validator: (val) => ["all", "image", "video"].includes(val),
        },
    },
    data: function () {
        return {
            mediaTypePreds: {
                all: () => true,
                image: (m) => this.isImage(m),
                video: (m) => this.isVideo(m),
            },
        }
    },
    icons: {
        mdiVideo,
    },
    computed: {
        dedupMedia() {
            let dedupMedia = this.dedup(this.gallery.media).filter(
                this.mediaTypePreds[this.mediaType]
            )
            dedupMedia.sort(
                (a, b) =>
                    new Date(b.created_at).getTime() -
                    new Date(a.created_at).getTime()
            )
            return dedupMedia
        },
        selectedIds() {
            return new Set(this.selected.map((el) => el.id))
        },
        mediaColumns() {
            // inverse aspect ratios of media
            let ars = this.dedupMedia.map((m) => {
                const a = m.width / m.height
                if (isNaN(a)) return 1
                return 1 / a
            })
            // this.numCol lists of media such that the sum of their inverse aspect ratios is minimal
            let cols = []
            let heights = []
            for (let i = 0; i < this.numCols; i++) {
                cols.push([])
                heights.push(0)
            }
            for (let i = 0; i < this.dedupMedia.length; i++) {
                let minIndex = this.indexOfSmallest(heights)
                cols[minIndex].push(this.dedupMedia[i])
                heights[minIndex] += ars[i]
            }
            return cols
        },
    },
    methods: {
        component(media) {
            return media.type === "video" ? "ResponsiveVimeo" : "OPicture"
        },
        indexOfSmallest(a) {
            var lowest = 0
            for (var i = 1; i < a.length; i++) {
                if (a[i] < a[lowest]) lowest = i
            }
            return lowest
        },
        isSelected(media) {
            return this.selectedIds.has(media.id)
        },
        dedup(media) {
            if (!media) return
            const hashes = new Set()
            return media.filter((item) => {
                if (
                    hashes.has(item.content_hash) &&
                    !this.selectedIds.has(item.id)
                )
                    return false
                hashes.add(item.content_hash)
                return true
            })
        },
        onSelect(media) {
            let selected = []
            if (this.selectedIds.has(media.id)) {
                selected = this.selected.filter((el) => el.id !== media.id)
            } else {
                selected = [...this.selected, media]
            }
            this.$emit("select", selected)
        },
    },
}
